import React from 'react';
import './QuickView.css';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const AcceptedFileTypesModal: React.FC<ModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white text-white rounded shadow-lg w-32r">
        <div className="flex justify-between items-center mb-4 bg-black pt-2 pb-2">
          <h1 className="text-lg font-bold w-full text-center">UPLOAD IMAGE DETAILS</h1>
          <button
            onClick={onClose}
            className="outline-none hover:outline-none close-btn border-0"
          >
            &times;
          </button>
        </div>
        <div className='text-black pl-16 pr-16 pb-16 pt-6'>
          <h3 className="text-sm font-bold mb-4 ">For Optimal Quality</h3>
          <ul className="space-y-2">
            <li className="flex items-start">
              <span className="text-blue-500 mr-2">✔</span>
              <p>The file must be a valid image type. Other file types accepted are: JPG, PSD, AI, CDR, PDF, PNG, DST, EPS, or SVG.</p>
            </li>
            <li className="flex items-start">
              <span className="text-blue-500 mr-2">✔</span>
              <p>300px resolution</p>
            </li>
            <li className="flex items-start">
              <span className="text-blue-500 mr-2">✔</span>
              <p>Does not include anything that is not a part of the design</p>
            </li>
            <li className="flex items-start">
              <span className="text-blue-500 mr-2">✔</span>
              <p>Full color</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AcceptedFileTypesModal;